<template>
  <div class="banner-body-wrap">
     <img v-if='bannerList.length == 1' @click="goLink(bannerList[0].link)" :src="bannerList[0].imageUrl" alt="" />
    <el-carousel v-else trigger="click" height="320px">
      <el-carousel-item v-for="item in bannerList" :key="item.id">
         <img @click="goLink(item.link)" :src="item.imageUrl" alt="" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import {
  get_queryBannerLeaderOpinion
} from '@/api/modules/home'
export default {
  name: 'Home',
  data () {
    return {
        bannerList:[],
      bannerImgSrc: './static/img/home/bannerBG.jpg'
    }
  },
  mounted(){
    this.getBannerList()
  },
  methods: {
    goLink(link){
      if(link){
         window.open(link,'_blank')
      }
    },
    getBannerList(){
      get_queryBannerLeaderOpinion().then((res) => {
        // banner
       this.bannerList =  res.data.tcCarouselEntities
      })
    }
    
  }
}
</script>

<style lang="scss" scoped>
.banner-body-wrap {
  height:320px;
  width: 100%;
  min-width: $base-width;
  // background: burlywood;
   img {
    width: 100%;
    height: 320px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/banner.vue